module.exports = __webpack_public_path__ + "static/media/13D.e9164155.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/13D.svg
// module id = 46
// module chunks = 0